export default {
    apiKey: "AIzaSyA1myPiMRxLxkAAqzh_j266BiqJyOI-tys",
    authDomain: "lending-master.firebaseapp.com",
    projectId: "lending-master",
    storageBucket: "lending-master.appspot.com",
    messagingSenderId: "671797981851",
    appId: "1:671797981851:web:fb55b9e5547432de6a4c3e",
    measurementId: "G-KMTEDLT4BK"
};
